export const DISTANCE_FROM_ITEM = 32;
export const DISTANCE_FROM_IN_EDITOR_ELEMENT = 10;
export const VERTICAL_MARGIN = 16;
export const TOP_BAR_HEIGHT = 82;
export const BOTTOM_VERTICAL_MARGIN = 20;
